import { render, staticRenderFns } from "./InfomationList.vue?vue&type=template&id=1bf31bce&scoped=true&"
import script from "./InfomationList.vue?vue&type=script&lang=js&"
export * from "./InfomationList.vue?vue&type=script&lang=js&"
import style0 from "./InfomationList.vue?vue&type=style&index=0&id=1bf31bce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf31bce",
  null
  
)

export default component.exports